const sitConfig = {
  Auth: {
    Cognito: {
      // identityPoolId: 'eu-west-1:cc52d7af-4991-4022-a616-f2468ca207a3',
      userPoolEndpoint: 'https://www.sit1.gb.moneysavingexpert.com/idp',
      userPoolId: 'eu-west-1_51sTqvrCg',
      userPoolClientId: '4bf90m50qi71ksdlgoedg070hl',
    },
  },
};

const preConfig = {
  Auth: {
    Cognito: {
      // identityPoolId: 'eu-west-1:5fb8e1e4-79be-4284-83c1-45cdb8a09a2c',
      userPoolEndpoint: 'https://www.pre1.gb.moneysavingexpert.com/idp',
      userPoolId: 'eu-west-1_83Y68XXNs',
      userPoolClientId: '1f7tfcmh6r47m3rmge96i4qu36',
    },
  },
};

const prodConfig = {
  Auth: {
    Cognito: {
      // identityPoolId: 'eu-west-1:ed52bcfc-50ae-4628-8540-2c45fce985d5',
      userPoolEndpoint: 'https://www.moneysavingexpert.com/idp',
      userPoolId: 'eu-west-1_yOfo91eGI',
      userPoolClientId: '4ijcpi16ospm0r3qe28fal8oe0',
    },
  },
};

export default {
  'www.sit1.gb.moneysavingexpert.com': sitConfig,
  'www.pre1.gb.moneysavingexpert.com': preConfig,
  'www.moneysavingexpert.com': prodConfig,
  default: preConfig,
};
